import { FormControl, FormControlLabel, Grid, Stack, Tab, Tabs, TextField, Box, Typography, Switch, FormGroup } from "@mui/material";
import FormPageHeader from "../utilities/FormPageHeader";
import { checkPassword, emailValidation, checkString, comparePassword, checkBlankSpace, checkSpecialChar } from "../utilities/FormValidation";
import { useCallback, useEffect, useRef, useState } from "react";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import jwtDecode from "jwt-decode";
import OAuthService from "src/app/auth/services/oAuthService";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
    const [password, setPassword] = useState();
    const [cpassword, setCPassword] = useState();
    const [tabValue, setTabValue] = useState(0);
    const [error, setError] = useState();
    const formRef = useRef(null);
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [userId, setUserId] = useState();
    const navigate = useNavigate()
    const [checksubmit, setCheckSubmit] = useState(false);
    const [validError, setValidError] = useState({});
    const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}`;
    const handleSubmit = async () => {
        const token = jwtDecode(localStorage.getItem('token'));
        setCheckSubmit(true)
        let model = {
            password: password,
            confirmPassword: cpassword
        }
        try {
            if (password && cpassword) {
                const resetmail = await OAuthService.addData(url + '/sendpwdresetmail?email=' + token?.email);
                if (resetmail) {
                    const getUserurl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${token.email}`;
                    const result = await OAuthService.getList(getUserurl);
                    const usertoken = result?.data?.token;
                    if (usertoken) {
                        const resetpassword = await OAuthService.addData(url + `/resetpassword?token=${usertoken}&password=${password}&passwordConfirm=${cpassword}`);
                    }
                }
                setSuccessMsg('Password updated suucessfully');
                setSnackState(true);
                setTimeout(() => { navigate('/sign-out') }, 800);
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }
    }

    const handleTabChange = (event, value) => {
        setTabValue(value);
    }

    useEffect(() => {
        const users = async () => {
            const token = jwtDecode(localStorage.getItem('token'));
            const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${token.email}`;
            const result = await OAuthService.getList(url);
            const user = result?.data;
            const url1 = process.env.REACT_APP_API_KEY_URL
            const url2 = user?._links.user.href.split("/api")[1]
            setUserId(`${url1}api${url2}`)

            // setUserId(user?._links.user.href.split('/').pop())
        }
        users();
    }, [])
    return (
        <div className="w-full overflow-scroll">
            <FormPageHeader
                componentName="New Password"
                // handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                currentPage={"Change Password"}
                successMsg={successMsg}
                snackState={snackState}
                error={error}
            >
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="secondary"
                    textColor="inherit"
                    sx={{ color: 'yellow' }}
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full border-b-1' }}
                >
                    <Tab label="General" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24">
                <FormControl
                    ref={formRef}
                    className="flex flex-col justify-center"
                >
                    <div className={tabValue !== 0 ? 'hidden' : ''}>
                        <Stack>
                            <label>New Password</label>
                            <TextField
                                className="mb-16"
                                type="password"
                                name="password"
                                error={(checksubmit && !password) || validError.password ? true : false}
                                value={password}
                                onChange={(e) => { setPassword(e.target.value); setValidError({ ...validError, password: checkPassword(e.target.value) }) }}
                                variant="outlined"
                                helperText={(checksubmit && !password) ? "This field is required" : validError.password}
                                InputLabelProps={{
                                    shrink: password ? true : false,
                                }}
                            />
                        </Stack>
                        <Stack>
                            <label>Confirm New Password</label>
                            <TextField
                                className="mb-16"
                                type="password"
                                name="cpassword"
                                error={(checksubmit && !cpassword) || validError.cpassword ? true : false}
                                value={cpassword}
                                helperText={(checksubmit && !cpassword) ? "This field is required" : validError.cpassword}
                                onChange={(e) => { setCPassword(e.target.value); setValidError({ ...validError, cpassword: comparePassword(e.target.value, password) }) }}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: cpassword ? true : false,
                                }}
                            />
                        </Stack>
                    </div>
                </FormControl>
            </div >

        </div >
    )
}

export default ChangePassword;
